<template>
  <button
    type="button"
    class="btn-icon"
    :title="label"
    :aria-label="label"
    :aria-pressed="theme.isDark"
    @click="theme.toggle()"
  >
    <AppIcon :name="theme.isDark ? 'sun' : 'moon'" />
  </button>
</template>

<script>
import AppIcon from './AppIcon.vue'
import { theme } from '@/stores/theme'

// Bascule clair ⇄ sombre. Le choix « system » reste disponible dans Mon profil.
export default {
  name: 'ThemeToggle',
  components: { AppIcon },
  setup() {
    return { theme }
  },
  computed: {
    label() {
      return this.theme.isDark ? 'Passer en thème clair' : 'Passer en thème sombre'
    }
  }
}
</script>